// extracted by mini-css-extract-plugin
export default {"container":"MainNav_container__yDC6C","active":"MainNav_active__QBy5E"};